// extracted by mini-css-extract-plugin
export default {"container":"_6gBJCpjQ3lxnqlIWMU2kaj","content":"_4vaCfInFMCZw35EdL7J8pg"};